import { Col } from "antd";
import styled, { keyframes } from "styled-components";
import Styles from "./TenantCard.styles";

const shimmer = keyframes`
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
`;

const Shimmer = styled.div<{ $w?: string; $h?: number; $radius?: number }>`
  width: ${(p) => p.$w ?? "100%"};
  height: ${(p) => p.$h ?? 14}px;
  border-radius: ${(p) => p.$radius ?? 6}px;
  background: linear-gradient(90deg, #FDF0F4 25%, #FBD9E3 37%, #FDF0F4 63%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;

const LogoSkeleton = styled(Shimmer)`
  width: 68px;
  height: 68px;
  border-radius: 50%;
  flex-shrink: 0;
`;

/**
 * Loading placeholder for TenantCard. Reuses the exact TenantCol/TenantCard
 * shell and matching internal heights so the swap to real cards produces no
 * layout shift (CLS).
 */
export const TenantSkeletonCard: React.FC<{ index?: number }> = ({ index }) => (
  <Styles.TenantCol xs={24} md={12} $index={index}>
    <Styles.TenantCard as="div" style={{ cursor: "default" }}>
      <div>
        <Styles.CardHeaderRow gutter={12} align="middle">
          <Col flex="none">
            <LogoSkeleton />
          </Col>
          <Styles.InfoCol flex="auto">
            <Shimmer $w="60%" $h={18} style={{ marginBottom: 8 }} />
            <Shimmer $w="80%" $h={13} style={{ marginBottom: 8 }} />
            <Shimmer $w="45%" $h={13} />
          </Styles.InfoCol>
        </Styles.CardHeaderRow>
      </div>

      <div>
        <Styles.CardDivider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Shimmer $w="70px" $h={22} />
          <Shimmer $w="90px" $h={14} />
        </div>
        <Shimmer $h={42} $radius={14} style={{ marginTop: 14 }} />
      </div>
    </Styles.TenantCard>
  </Styles.TenantCol>
);
